

export default (() => {

  var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(["disableCookies"]);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function () {
    var u = "//derhaeuptling.de/matomo/";
    _paq.push(['setTrackerUrl', u + 'matomo.php']);
    _paq.push(['setSiteId', '1']); // 1 = tracked-site-id
    var d = document, g = d.createElement('script'), s = d.getElementById('main_script');
    g.type = 'text/javascript';
    g.async = true; g.defer = true; g.src = u + 'matomo.php'; s.parentNode.insertBefore(g, s);

  })();


})()
